import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'
import { Tasks } from '@/features/tasks'

const tasksSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
  status: z.string().optional().catch(''),
  priority: z.string().optional().catch(''),
  category: z.string().optional().catch(''),
  search: z.string().optional().catch(''),
  boardId: z.string().optional().catch(''),
  view: z.enum(['list', 'kanban']).optional().catch('list'),
  scope: z.enum(['my', 'all']).optional().catch('my'),
  // The dashboard's "Unassigned Tasks" tile door (role-dashboards phase 5c
  // follow-ups, B3) — filters the list to tasks with no assignee, the same
  // condition the tile's own count used.
  unassignedOnly: z.boolean().optional().catch(undefined),
  // The dashboard's "Overdue Tasks" tile door (role-dashboards phase 5c
  // follow-ups) — filters to `dueAt < now` + open status, the same condition
  // the tile's own count used. Used to be sent as `status: 'overdue'`, which
  // isn't a real task-status enum member, so the API's status whitelist
  // silently stripped it and the door opened the ENTIRE org task list.
  overdue: z.boolean().optional().catch(undefined),
  // Rulings 14b/14c: a compliance deep link opens a specific task (`?task=`)
  // or arrives pre-filtered to an entity's tasks (`?entityType=&entityId=`,
  // e.g. a Standards card's "N open tasks" link) — spec §7.1 "never a dead
  // button".
  task: z.string().optional(),
  entityType: z.string().optional(),
  entityId: z.string().optional(),
  // A Standards card's "N open tasks" door (PR #511 review F141) — lists only
  // pending / in-progress tasks, the same condition the card's count used.
  openOnly: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/_organization/tasks/')({
  beforeLoad: async () => requireActiveSubscription(),
  component: Tasks,
  validateSearch: tasksSearchSchema,
})
